// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.4_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.4_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Hold all third party libraries override
*/

/*
OpenLayers
*/
.ol-scale-line-inner {
  display: none;
}

/*
yet-another-react-lightbox
*/

.yarl__toolbar {
  gap: 12px !important;
}

.yarl__button {
  background-color: white !important;
  color: #000 !important;
  border-radius: 50% !important;
  width: 44px !important;
  height: 44px !important;
  padding: 0px !important;
}

.yarl__button:focus-visible {
  background-color: #515ba5 !important;
  color: #fff !important;
}

.yarl__button:disabled {
  opacity: 0.25 !important;
}

.yarl__button.keyboard-focused {
  border: none !important;
}

.yarl__button > svg {
  width: 24px !important;
  height: 24px !important;
}

.yarl__navigation_prev > svg,
.yarl__navigation_next > svg {
  width: 36px !important;
  height: 36px !important;
}

.yarl__navigation_prev {
  left: 8px !important;
}

.yarl__navigation_next {
  right: 8px !important;
}
`, "",{"version":3,"sources":["webpack://./src/ui/style/vendor.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;;CAEC;AACD;EACE,aAAa;AACf;;AAEA;;CAEC;;AAED;EACE,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/*\nHold all third party libraries override\n*/\n\n/*\nOpenLayers\n*/\n.ol-scale-line-inner {\n  display: none;\n}\n\n/*\nyet-another-react-lightbox\n*/\n\n.yarl__toolbar {\n  gap: 12px !important;\n}\n\n.yarl__button {\n  background-color: white !important;\n  color: #000 !important;\n  border-radius: 50% !important;\n  width: 44px !important;\n  height: 44px !important;\n  padding: 0px !important;\n}\n\n.yarl__button:focus-visible {\n  background-color: #515ba5 !important;\n  color: #fff !important;\n}\n\n.yarl__button:disabled {\n  opacity: 0.25 !important;\n}\n\n.yarl__button.keyboard-focused {\n  border: none !important;\n}\n\n.yarl__button > svg {\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.yarl__navigation_prev > svg,\n.yarl__navigation_next > svg {\n  width: 36px !important;\n  height: 36px !important;\n}\n\n.yarl__navigation_prev {\n  left: 8px !important;\n}\n\n.yarl__navigation_next {\n  right: 8px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
